import {
  getDisplayPhone as getDisplayPhoneShared,
  getDisplayValue as getDisplayValueShared,
} from "utils/phoneUtils";

export function getDisplayPhone(
  telephone: { areaCode: string; number: string; countryCode: string },
  cellphone: { areaCode: string; number: string; countryCode: string },
): string {
  return getDisplayPhoneShared(telephone, cellphone, "-");
}

export const getDisplayValue = getDisplayValueShared;
